import { Component, OnInit, ViewChild } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  NwbFilter,
  NwbFilterGroup,
  NwbFilterRoutingBuilder,
  NwbPageEvent,
  NwbPaginatorComponent,
  NwbSort,
  Sort
} from '@wizishop/ng-wizi-bulma';
import { DataService } from '../services/data.service';
import { FileSaverService } from 'ngx-filesaver';

@Component({
  providers: [],
  templateUrl: './rinnovi.component.html',
  styleUrls: ['./rinnovi.component.css']
})
export class RinnoviComponent implements OnInit {
  displayedColumns: string[] = ['number', 'data', 'data2', 'contraente', 'ufficio', 'importo', 'scarica'];
  data: GithubIssue[] = [];

  @ViewChild(NwbPaginatorComponent, { static: true })
  paginator;
  @ViewChild(NwbSort, { static: true })
  sort;

  resultsLength = 0;
  isLoadingResults = false;
  isRateLimitReached = false;

  sortActive = 'title';
  sortStart = 'asc';

  dataTableFilters = {
    sort: this.sortActive,
    order: this.sortStart,
    pageIndex: 0,
    q: 'repo:angular/angular'
  };

  filterGroup: NwbFilterGroup;

  constructor(private dataService: DataService, private filterRoutingBuilder: NwbFilterRoutingBuilder, private fileSaverService: FileSaverService) { }

  ngOnInit() {

    this.filterGroup = this.filterRoutingBuilder.group(this.dataTableFilters, 'datatable');

    this.filterGroup.valuesChange$.subscribe(filters => {
      this.updateFilters(filters);
      this.fetchData();
    });

    this.updateFilters(this.filterGroup.getFilters());

    this.fetchData();

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe((sort: Sort) => {
      this.filterGroup.setValues({
        pageIndex: 0,
        sort: sort.active,
        order: sort.direction
      });
    });

    this.paginator.page.subscribe((page: NwbPageEvent) => {
      this.filterGroup.set('pageIndex', page.pageIndex);
    });
  }

  private updateFilters(filters: NwbFilter[]) {
    filters.forEach(filter => {
      this.dataTableFilters[filter.key] = filter.value;
    });
  }

  printLettera(id: string, data: string) {
    this.dataService.getLetteraRinnovoAdesione(data).subscribe(file => {
      this.fileSaverService.save(file, `lettera_${id}.pdf`);
    });
  }

  private fetchData() {
    this.isLoadingResults = true;
    this.dataService.rinnovi
      .pipe(
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.length;
          return data;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return of([]);
        })
      )
      .subscribe(data => (this.data = data));
  }
}

export interface GithubApi {
  items: GithubIssue[];
  total_count: number;
}

export interface GithubIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}
